/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
//Material imports
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import MessageFlagDialog from "../../dialogs/message-flag-dialog/MessageFlagDialog";
import SecureDataRequestDialog from "../../dialogs/secure-data-request-dialog/SecureDataRequestDialog";
import { useExpertMessageResponseContext } from "../../../../expert";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import DotsIcon from "@limitless/icons/EllipsisVertical";
import Menu from "@limitless/modern/navigation/menu/Menu";
const MessageEditorActions = ({
  t,
  message,
  classes
}) => {
  const [showSecureData, setShowSecureData] = React.useState(false);
  const [flagType, setFlagType] = React.useState();
  const [conversationMenuAnchorEl, setConversationMenuAnchorEl] = React.useState(null);
  const {
    clearMessageResponse
  } = useExpertMessageResponseContext();
  const {
    showForwardMessageCodes,
    allowReportMessage,
    allowSecureDataRequest
  } = message.conversationState;
  const conversationMenuOpen = Boolean(conversationMenuAnchorEl);
  const dialogs = [];
  const handleToggleSecureDataDialog = show => () => {
    setShowSecureData(show);
  };
  const handleConversationMenuClick = event => {
    setConversationMenuAnchorEl(event.currentTarget);
  };
  const handleConversationMenuClose = () => {
    setConversationMenuAnchorEl(null);
  };
  if (flagType) {
    dialogs.push(/*#__PURE__*/React.createElement(MessageFlagDialog, {
      key: 1,
      type: flagType,
      onCancel: () => setFlagType(null)
    }));
  }
  if (showSecureData) {
    dialogs.push(/*#__PURE__*/React.createElement(SecureDataRequestDialog, {
      key: 4,
      onCancel: handleToggleSecureDataDialog(false),
      t: t
    }));
  }
  const getListItemCount = React.useMemo(() => {
    let count = 1;
    if (showForwardMessageCodes) {
      count = count + 1;
    }
    if (allowReportMessage) {
      count = count + 1;
    }
    if (allowSecureDataRequest) {
      count = count + 1;
    }
    return count;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(DotsIcon, {
      sx: {
        marginRight: "10px"
      }
    }),
    label: "more",
    tooltip: "More",
    className: classes.icon,
    tooltipPlacememnt: "top",
    id: "conversationMenuButton",
    "aria-controls": conversationMenuOpen ? "options-menu" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": conversationMenuOpen ? "true" : undefined,
    onClick: handleConversationMenuClick
  }), /*#__PURE__*/React.createElement(Menu, {
    id: "options-menu",
    anchorEl: conversationMenuAnchorEl,
    open: conversationMenuOpen,
    onClose: handleConversationMenuClose,
    onBlur: handleConversationMenuClose,
    MenuListProps: {
      "aria-labelledby": "conversationMenuButton"
    },
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    classes: {
      paper: getListItemCount > 2 ? classes.dialogRoot : classes.dialogRootForSingleItem
    }
  }, showForwardMessageCodes && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setFlagType("escalation"),
    id: "forwardButton"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Forward back to client")
  })), allowReportMessage && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => setFlagType("report"),
    id: "reportButton"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Report to Limitless")
  })), allowSecureDataRequest && message.messageConfig && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleToggleSecureDataDialog(true),
    id: "requestDataButton"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Request Sensitive Data")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => {
      handleConversationMenuClose();
      clearMessageResponse();
    },
    id: "deleteButton"
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Remove all text from reply area")
  }))), dialogs);
};
export default withi18n(MessageEditorActions);
MessageEditorActions.propTypes = {
  message: PropTypes.object.isRequired,
  classes: PropTypes.object,
  t: PropTypes.func.isRequired
};